import { PAGE_FAQ_MEMBERSHIP_SECTION } from '@store/constants/routes';
import { useTranslation, Trans } from '@yoweb/next-i18next';
import { Text } from '@yoweb/ui/components/typography';
import { jsx as _jsx } from "react/jsx-runtime";
export var Disclaimer = function Disclaimer(props) {
  var _useTranslation = useTranslation('pricing'),
      t = _useTranslation.t;

  var basePrice = props.basePrice,
      useSubscriptionTrialRepeatingUi = props.useSubscriptionTrialRepeatingUi,
      useSubscriptionTrialOnceUi = props.useSubscriptionTrialOnceUi,
      hasCoupon = props.hasCoupon,
      discountPrice = props.discountPrice,
      discountMonths = props.discountMonths,
      initialOfferMonths = props.initialOfferMonths,
      initialOfferDays = props.initialOfferDays,
      initialOfferPriceFormatted = props.initialOfferPriceFormatted,
      disclaimerPretext = props.disclaimerPretext;
  var disclaimerPath = 'common.disclaimer';
  var disclaimer = "".concat(disclaimerPath, ".regular");
  var values = {
    basePrice: basePrice
  };

  if (hasCoupon) {
    values.discountPrice = discountPrice;

    if (useSubscriptionTrialRepeatingUi) {
      disclaimer = "".concat(disclaimerPath, ".coupon-combo");
      values.count = initialOfferMonths;
      values.initialOfferPrice = initialOfferPriceFormatted;
      values.discountMonths = discountMonths;
    } else if (useSubscriptionTrialOnceUi) {
      disclaimer = "".concat(disclaimerPath, ".coupon-trial-months");
      values.count = initialOfferMonths;

      if (initialOfferDays && initialOfferDays > 0) {
        disclaimer = "".concat(disclaimerPath, ".coupon-trial-days");
        values.count = initialOfferDays;
      }

      values.initialOfferPrice = initialOfferPriceFormatted;
      values.disclaimerPretext = disclaimerPretext;
    } else {
      disclaimer = "".concat(disclaimerPath, ".coupon");
      values.count = discountMonths;
    }
  }

  return /*#__PURE__*/_jsx(Text, {
    "data-testid": "pricing-disclaimer",
    size: {
      _: 'xs',
      lg: 'sm'
    },
    weight: {
      _: 'bold',
      lg: 'regular'
    },
    variant: "muted2",
    children: /*#__PURE__*/_jsx(Trans, {
      t: t,
      i18nKey: disclaimer,
      values: values,
      components: [/*#__PURE__*/_jsx(Text, {
        as: "a",
        size: {
          _: 'xs',
          lg: 'sm'
        },
        href: PAGE_FAQ_MEMBERSHIP_SECTION,
        textDecoration: "underline",
        target: "_blank",
        rel: "noreferrer"
      }, 0)]
    })
  });
};